"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class FilterIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { height: "24", viewBox: "0 0 1792 1792", width: "24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M1595 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z" })))));
    }
}
exports.FilterIcon = FilterIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/filter.tsx
// module id = 3361
// module chunks = 0